var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9415 0 36 8.05852 36 18C36 27.9415 27.9415 36 18 36C8.05852 36 0 27.9415 0 18C0 8.05852 8.05852 0 18 0Z",
    fill: "#E05145"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_97_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 13.0374 13.0374 9 18 9C20.0043 9 21.9013 9.64483 23.4861 10.8648L21.3946 13.5816C20.4147 12.8273 19.2409 12.4286 18 12.4286C14.9279 12.4286 12.4286 14.9279 12.4286 18C12.4286 21.0721 14.9279 23.5714 18 23.5714C20.4743 23.5714 22.577 21.9503 23.3016 19.7143H18V16.2857H27V18C27 22.9626 22.9626 27 18 27C13.0374 27 9 22.9626 9 18Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_97_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.488b802e45cba70ff7704875705fb8d7.svg";
export { ForwardRef as ReactComponent };